import { notEmpty } from '~/infra/utils';
export function templateToCommonWithId(template) {
    var _ref;
    var _template_legalTermsDocuments;
    return {
        id: template.id,
        coverLetter: template.coverLetter,
        extraClause: template.extraClause,
        requirePaymentMethod: template.requirePaymentMethod,
        allowManualPayments: template.allowManualPayments,
        isExistingCustomer: template.isExistingCustomer,
        customNotificationText: template.customNotificationText,
        services: template.services,
        serviceBundles: template.serviceBundles,
        netTerms: template.netTerms,
        legalTermsDocuments: (_ref = (_template_legalTermsDocuments = template.legalTermsDocuments) === null || _template_legalTermsDocuments === void 0 ? void 0 : _template_legalTermsDocuments.filter(notEmpty)) !== null && _ref !== void 0 ? _ref : [],
        coverCreditCardFees: template.feeControls.coverCreditCardFees,
        amendmentsApprovalMethod: template.amendmentsApprovalMethod,
        invoicesApprovalMethod: template.invoicesApprovalMethod,
        requestAccountantAccess: template.requestAccountantAccess,
        introVideo: template.introVideo,
        expirationDate: template.expirationDate
    };
}
